export default "__VITE_ASSET__CpOR$WJL__"